import { useGetApplication } from 'app/hooks';

import { default as catalogService, default as catalogservice } from '../Catalog.service';
import { type CatalogTypeModel } from '../CatalogType/types';

import type { CatalogValue } from './catalogValue.model';

export const useCatalogList = (type: string, params: any = {}) => {
  const response = useGetApplication<Array<CatalogValue>>({
    url: catalogservice.baseCatalogUrl() + '/' + type,
    params
  });

  return response;
};
export const useCatalogListByParent = (type: string, parent: string, onLoad = true) => {
  const response = useGetApplication<Array<CatalogValue>>(
    {
      url: catalogservice.baseCatalogUrl() + '/' + type,
      params: { parent: parent }
    },
    onLoad
  );

  return response;
};

export const useCatalogByParent = (parentId: string) => {
  const response = useGetApplication<Array<CatalogValue>>({
    url: catalogservice.baseCatalogUrl() + '/parent/' + parentId,
    params: undefined
  });

  return response;
};

export const useCatalogTypeListAll = () => {
  return useGetApplication<Array<CatalogTypeModel>>({
    url: catalogService.baseCatalogTypeUrl() + '/all',
    params: {}
  });
};
